<template>
    <div>
        <el-button type="primary" size="mini" @click="getData" plain>跟进记录</el-button>
        <el-dialog
            title="案例跟进记录"
            :visible.sync="showdialog"
            width="400px"
            append-to-body>

            <el-timeline>
                <el-timeline-item 
                    v-for="(item, index) in logs"
                    :key="index"
                    :timestamp="item.addDate"
                    placement="top"
                    type="primary"
                    size="normal">
                    <div>{{item.remark}}</div>
                </el-timeline-item>
            </el-timeline>

        </el-dialog>
        
    </div>
</template>

<script>
export default {
    name: 'TutorLog',
    data() {
        return {
            showdialog: false,
            logs: [],
        }
    },
    props: {
        id: {
            type: String,
            default: ''
        },
    },
    methods: {
        getData() {
            this.showdialog = true;
            var params = {
                id: this.id,                
            }
            this.$api.getTutorCaseLogs(params).then(
                data=>{
                    this.logs = data;
                }
            )
        }
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
</style>